export default "__VITE_ASSET__Wo7y17va__"